enum SubscriptionTimezoneContinent {
  africa = "africa",
  america = "america",
  antarctica = "antarctica",
  asia = "asia",
  atlantic = "atlantic",
  australia = "australia",
  europe = "europe",
  indian = "indian",
  pacific = "pacific",
}

export const subscriptionTimezoneContinentAsString = (
  subscriptionTimezoneContinent: SubscriptionTimezoneContinent
): string => {
  switch (subscriptionTimezoneContinent) {
    case SubscriptionTimezoneContinent.africa:
      return "Afrique";
    case SubscriptionTimezoneContinent.america:
      return "Amérique";
    case SubscriptionTimezoneContinent.antarctica:
      return "Antarctique";
    case SubscriptionTimezoneContinent.asia:
      return "Asie";
    case SubscriptionTimezoneContinent.atlantic:
      return "Atlantique";
    case SubscriptionTimezoneContinent.australia:
      return "Australie";
    case SubscriptionTimezoneContinent.europe:
      return "Europe";
    case SubscriptionTimezoneContinent.indian:
      return "Indien";
    case SubscriptionTimezoneContinent.pacific:
      return "Pacifique";
    default:
      return "";
  }
};

export default SubscriptionTimezoneContinent;
